import React from 'react';
import PropTypes from 'prop-types';

const AutocodeRunButton = props => {
  const {
    title,
    isRunEnabled,
    autocodeRun,
    btnClass = 'autocode-runbutton',
    handleDisableClass = false,
  } = props;
  return (
    <button
      type="button"
      disabled={!isRunEnabled}
      className={handleDisableClass ? btnClass : `button ${btnClass}`}
      data-test="autocodeRunBtn"
      onClick={autocodeRun}
    >
      {title}
    </button>
  );
};

AutocodeRunButton.propTypes = {
  title: PropTypes.string.isRequired,
  isRunEnabled: PropTypes.bool,
  autocodeRun: PropTypes.func.isRequired,
  btnClass: PropTypes.string,
  handleDisableClass: PropTypes.bool,
};

export default AutocodeRunButton;
